import canUseDOM from "../canUseDOM";
export default canUseDOM ? window : {};